import { SET_LIVECHAT_STATUS } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types"

export interface LiveChatSetState {
    loaded: boolean
}

const initialState: LiveChatSetState = {
    loaded: false
}

export function setLiveChatStateReducer(state = initialState, action: AppAction) {
    const { value } = action;

    switch (action.type) {
        case SET_LIVECHAT_STATUS:
            return {
                ...state,
                loaded: value
            }
        default:
            return state;
    }
}